import { createFormHooks } from './utils';

/**
 * Shared hooks for form field and form actions to use in shared components which are use in multiple places.
 */
export const {
  useFormField: useUnknownFormField,
  useFormActions: useUnknownFormActions,
} = createFormHooks();